<template>
  <widget/>
</template>

<script>
import config from '@/core/config'

import '@/styles/reset.scss'
import '@/styles/main.scss'

export default {

  beforeMount() {
    
    if(!this.$state.internal) {

      if(!window.matchMedia) return;
          
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      
      media.addEventListener('change', e => (this.$state.dark = !!e.matches));
    }
    else {
        
      const widget = document.querySelector(`[data-sapo-widget-id="${this.$state.id}"]`);

      if(!widget) return;

      const observer = new MutationObserver(e => (this.$state.dark = widget.classList.contains('dark')));
      
      observer.observe(widget, {
        attributes: true, 
        attributeFilter: ['class'],
        childList: false, 
        characterData: false
      });
    }
  },

  computed: {
    dev() {
      
      return this.$dev ? JSON.stringify(this.$_swsk) : null;
    }
  },

  watch: {
    $state: {
      deep: true,
      handler(state) {

        const data = {
          ...state
        };

        this.$active(data);

        window.$_swsk.log('state changed', data);
      }
    },
    $_swsk: {
      deep: true,
      handler(value) {

        if(!!window.$_swsk && !!window.$_swsk.events) {

          clearTimeout(window.$_swsk.events.storageDelay);

          window.$_swsk.events.storageDelay = setTimeout(() => !!window.localStorage && window.localStorage.setItem(process.env.VUE_APP_STORAGE_KEY, JSON.stringify(value || {})), config.storeDelay);
        }
      }
    }
  }
}
</script>